import React from "react";
import "./ModerationVisitHeader.css";
import { useSubject } from "../context/SubjectContext";
import ErrorMessageContainer from "./form/ErrorMessageContainer";
import { getQualificationTitle } from "../utils/utils";

const ModerationVisitHeader = ({
  formData,
  onReviewSubmit,
  onBack,
  onSubmitRequest,
  onEditRequest,
  duplicateUnits,
  isReviewPage = false,
  showActions = true,
  selectedUnits = [],
  showConsortiaError = false,
  currentCentreType = '',
  isConsortiumRegistered,
  isMixed = false,
  isConsortiumUnitsSelected
}) => {
  const { subjectData, subjects } = useSubject();
  const { selectedSubject, selectedSubjectCode, selectedSubjectId } = subjectData || {};
  return (
    <div className="pt-5 subject-header-fixed moderation-visit-header">
      <div className="columns mb-0">
        <div className="column">
          <p className="is-size-6 has-text-weight-bold">
            {getQualificationTitle(subjects, selectedSubjectId)}
          </p>
          <h1 className="title is-2 mb-0">
            {selectedSubject || "Subject Name"}{" "} 
            <span className="is-size-6 has-text-weight-normal">
             {selectedSubjectCode || (selectedSubject === "Oracy" ? "H055" : "")} {/* Added a fallback for Oracy when selectedSubjectCode is empty */}
            </span>
          </h1>
          <p className="xbox xnotification is-info mt-0">
            Moderation visit request
          </p>
        </div>
        <div className="column is-narrow">
          {showActions && (
            <div className="buttons pt-4 mb-0">
              {isReviewPage ? (
                <>
                  <button
                    className="button is-success"
                    onClick={onSubmitRequest}
                    type="button"
                  >
                    Submit request
                  </button>
                  <button
                    className="button is-primary is-outlined"
                    onClick={onEditRequest}
                    type="button"
                  >
                    Edit request
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="button is-primary"
                    onClick={onReviewSubmit}
                    type="button"
                  >
                    Review and submit request
                  </button>
                  <button
                    className="button is-primary is-outlined"
                    onClick={onBack}
                    type="button"
                  >
                    Back
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <hr className="mb-0 mt-2" />
      {(showConsortiaError || (duplicateUnits || []).filter((unit) => selectedUnits.includes(unit))
        .length > 0) && (
        <ErrorMessageContainer
        formData={formData}
          values={duplicateUnits.filter((unit) => selectedUnits.includes(unit))}
          showConsortiaError={showConsortiaError}
          currentCentreType={currentCentreType}
          isConsortiumRegistered={isConsortiumRegistered}
           isMixed={isMixed}
           isConsortiumUnitsSelected={isConsortiumUnitsSelected}
        />
      )}
    </div>
  );
};

export default ModerationVisitHeader;
